import type { ReactNode } from 'react';

import type { Theme } from '@/shared/ui';
import { TableCell } from '@/shared/ui';

import { TABLE_ROW_HEIGHT_PX } from '@/config/constants';

import RestrictedIconWithTooltip from './RestrictedIconWithTooltip';

export const renderEmptyCells = (count: number) =>
  Array.from({ length: count }, (_, index) => <TableCell key={`empty-cell-${index + 1}`} />);

export const getMaxHeight = (height: number | undefined): string =>
  height ? `${height * TABLE_ROW_HEIGHT_PX + 47 - TABLE_ROW_HEIGHT_PX / 1.5}px` : 'fit-content';

export const getRowBackgroundColor = (
  restrictedData: boolean,
  index: number,
  theme: Theme
): string => {
  if (restrictedData) return theme.palette.table.infoRowBg;
  if (index % 2 === 1) return 'gx.tileLight';
  return 'inherit';
};

export const renderRestrictedOrValue = (
  value: ReactNode,
  restricted: boolean | undefined
): ReactNode => (restricted ? <RestrictedIconWithTooltip /> : value);
